import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import smsNumbersIndex from "./smsNumbers/index";
import profile from "./profile.module";
import modal from "./modal/index";
import toast from "@/core/services/store/toast";
import global from "@/core/services/store/global";
import user from "./user";
import wallet from "@/core/services/store/wallet";
import tutorial from "./tutorials/index";
import locals from "./locals";
import phonebook from "./phonebook";
import aiSmsSuggestions from "./aiSmsSuggestions";
import social from "./social";
import voiceOperators from "./smsNumbers/voiceOperators";
import socialOperators from "./smsNumbers/socialOperators";

import menu from "./menu";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    smsNumbersIndex,
    breadcrumbs,
    profile,
    modal,
    toast,
    global,
    user,
    menu,
    wallet,
    tutorial,
    locals,
    phonebook,
    aiSmsSuggestions,
    social,
    voiceOperators,
    socialOperators,
  },
});
